import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { AdAsset } from "../types/ad-asset";

const useAdAssets = (adAssetGroupId: number, brandId: number) => {
  const params = new URLSearchParams();

  params.append("ad_asset_group_id", adAssetGroupId.toString());
  params.append("brand_id", brandId.toString());

  const { data, error, isLoading, mutate } = useSWR<AdAsset[]>(
    `${RelativeUrl}/ad_assets?${params.toString()}`,
    fetcher
  );

  return {
    adAssets: data || [],
    isLoading,
    error: error ? "Failed to fetch ad assets" : null,
    invalidateAdAssetsCache: mutate
  };
};

export default useAdAssets;
